var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (containerAttributes, fieldsetCounter, fileInputAttributes, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_mixins["dropzone"] = pug_interp = function(model, single, id, tags, employeeId, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
containerAttributes = {}
fileInputAttributes = {}
if (single) {
containerAttributes = { 'made-dropzone-single' : 'true' }
fileInputAttributes = { 'made-file-single' : 'true' }
}
else {
fileInputAttributes = { multiple : 'multiple' }
}
if (!id) {
id = 'uploader'
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "dropzone-container","made-dropzone": pug.escape(model)},containerAttributes,attributes]), true)) + "\u003E\u003Cdiv class=\"dropzone-inner-container\"\u003E";
if (employeeId) {
pug_html = pug_html + "\u003Cfile-chooser" + (pug.attr("files", model, true, true)+pug.attr("filter-tags", tags, true, true)+pug.attr("employee-id", employeeId, true, true)) + "\u003E\u003C\u002Ffile-chooser\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + ("\u003Cdiv class=\"drag-and-drop-label\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fsvg\u002Ficon-download.svg\"\u003E" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)));
if (single) {
pug_html = pug_html + "\u003Cspan\u003EDatei hierherziehen\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003EDateien hierherziehen\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"divider\"\u003Eoder\u003C\u002Fdiv\u003E\u003Cdiv class=\"file-input\"\u003E\u003Cinput" + (pug.attrs(pug.merge([{"id": pug.escape(id),"type": "file","made-file-input": pug.escape(model),"style": "visibility:hidden","data-cy": pug.escape(cyData)},fileInputAttributes]), true)) + "\u003E";
if (single) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDatei auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
else {
pug_html = pug_html + "\u003Clabel" + (pug.attr("for", id, true, true)) + "\u003E\u003Cspan class=\"button\"\u003EDateien auswählen\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"files\"\u003E";
if (block) {
block && block();
}
else
if (single) {
pug_html = pug_html + "\u003Cspan" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)) + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-if", model +' && !'+ model +'._id', true, true)+pug.attr("ng-click", model + '=undefined', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca" + (pug.attr("ng-if", model +'._id', true, true)+pug.attr("ng-href", '/gridfs?id={{'+ model +'._id}}', true, true)+" target=\"_blank\" rel=\"noreferrer\"") + "\u003E" + (pug.escape(null == (pug_interp = ' {{ '+ model +'.name }} ({{ '+ model +'.size | filesize }})') ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"files\""+pug.attr("ng-repeat", '(index, file) in ' + model, true, true)) + "\u003E\u003Cspan ng-if=\"!file._id\"\u003E{{ file.name }} ({{ file.size | filesize }})\u003C\u002Fspan\u003E\u003Ca" + (pug.attr("ng-click", model + '.splice(index, 1)', true, true)) + "\u003E\u003Ci class=\"font-icon icon-close right\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca ng-if=\"file._id\" ng-href=\"\u002Fgridfs?id={{ file._id }}\" target=\"_blank\" rel=\"noreferrer\"\u003E{{ file.filename }} ({{ file.meta.created *1000 | date }}, {{ file.length | filesize }})\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Ch1\u003EBonus Projekt anlegen\u003C\u002Fh1\u003E\u003Cdiv class=\"cockpit-panel auto-resize\" overlay=\"$ctrl.loading.main\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EInformation\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"column small-6\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"title": "Bezeichnung","key": "$ctrl.bonus_project.name","required": pug.escape(true),"data-cy": "vn.cockpit.bonus.createProjectDialog.inputProjectName","validationMessages": {"required":"Es wird eine Eingabe benötigt"},"attributes": {"ng-disabled":"!$ctrl.can_edit"}}
});
pug_html = pug_html + "\u003C!--+input(--\u003E\u003C!--  title=\"Bezeichnung\"--\u003E\u003C!--  key=\"$ctrl.bonus_project.description\"--\u003E\u003C!--  required--\u003E\u003C!--  validationMessages={--\u003E\u003C!--    'required': 'Es wird eine Eingabe benötigt'--\u003E\u003C!--  }--\u003E\u003C!--  attributes={--\u003E\u003C!--    'ng-disabled': '!$ctrl.can_edit'--\u003E\u003C!--    }--\u003E\u003C!--)--\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.bonus_project.project_type","title": "Bonustyp","required": pug.escape(true),"data-cy": "vn.cockpit.bonus.createProjectDialog.selectProjectType","validationMessages": {"required":"Es wird eine Eingabe benötigt"},"attributes": {"ng-options":"bonus_project_type.id as bonus_project_type.display for bonus_project_type in $ctrl.BONUS_PROJECT_TYPES","ng-change":"$ctrl.selectedBonusProjectType()","ng-disabled":"!$ctrl.can_edit"}}
});
pug_html = pug_html + "\u003Cdiv ng-repeat=\"config_field in $ctrl.bonus_project.config_fields.metadata\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project, (config_field.parent))[config_field.key]","title": "{{config_field.title}}","id": "string_input.{{config_field.parent}}.{{config_field.key}}","data-cy": "vn.cockpit.bonus.createProjectDialog.inputIndividualHeadline","groupAttributes": {"ng-if":"config_field.type === 'string_input' && $ctrl.lodash.get(config_field, 'settings.is_visible', true)"},"attributes": {"ng-disabled":"!$ctrl.canEditConfigKey(config_field)"}}
});
pug_mixins["input"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project, (config_field.parent))[config_field.key]","title": "{{config_field.title}}","id": "integer_input.{{config_field.parent}}.{{config_field.key}}","validationId": "\"integer_input.\" + config_field.parent + \".\" + config_field.key","data-cy": "{{config_field.cyData}}","groupAttributes": {"ng-if":"config_field.type === 'integer_input' && $ctrl.lodash.get(config_field, 'settings.is_visible', true)"},"attributes": {"ng-disabled":"!$ctrl.canEditConfigKey(config_field)","ng-required":"$ctrl.lodash.get(config_field, 'settings.is_required', true)","vn-currency":"{{ config_field.settings.currency }}","vn-min":"{{ $ctrl.lodash.get(config_field, 'settings.min', false) }}","vn-max":"{{ $ctrl.lodash.get(config_field, 'settings.max', false) }}"},"validationMessages": {"required":"Es wird eine Eingabe benötigt","vnMin":"Geben Sie einen Tag zwischen {{$ctrl.lodash.get(config_field, 'settings.min', null)}}. und {{$ctrl.lodash.get(config_field, 'settings.max', null)}}. an","vnMax":"Geben Sie einen Tag zwischen {{$ctrl.lodash.get(config_field, 'settings.min', null)}}. und {{$ctrl.lodash.get(config_field, 'settings.max', null)}}. an"}}
});
pug_mixins["checkbox"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project, (config_field.parent))[config_field.key]","title": "{{config_field.title}}","id": "checkbox.{{config_field.parent}}{{config_field.key}}","data-cy": "{{config_field.cyData}}","groupAttributes": {"ng-if":"config_field.type === 'checkbox' && $ctrl.lodash.get(config_field, 'settings.is_visible', true)"},"attributes": {"ng-disabled":"!$ctrl.canEditConfigKey(config_field)"}}
});
pug_mixins["select"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project, (config_field.parent))[config_field.key]","title": "{{config_field.title}}","id": "select.{{config_field.parent}}{{config_field.key}}","required": pug.escape(true),"data-cy": "{{config_field.cyData}}","validationMessages": {"required":"Es wird eine Eingabe benötigt"},"groupAttributes": {"ng-if":"config_field.type === 'select' && $ctrl.lodash.get(config_field, 'settings.is_visible', true)"},"attributes": {"ng-options":"option.id as option.display for option in $ctrl.lodash.get($ctrl, (config_field.options.parent), $ctrl)[config_field.options.key]","ng-disabled":"!$ctrl.canEditConfigKey(config_field)"}}
});
pug_html = pug_html + "\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"dateInput\" date-refocus=\"true\" ng-if=\"config_field.type === 'datetime' &amp;&amp; $ctrl.lodash.get(config_field, 'settings.is_visible', true)\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project, (config_field.parent))[config_field.key]","title": "{{config_field.title}}","id": "date.{{config_field.parent}}.{{config_field.key}}","validationId": "\"date.\" + config_field.parent + \".\" + config_field.key","data-cy": "{{config_field.cyData}}","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-use-utc":"true","vn-date-min":"{{$ctrl.getDateConfigSettings(config_field, 'settings.date.min.key', 'date')}}","vn-date-max":"{{$ctrl.getDateConfigSettings(config_field, 'settings.date.max.key', 'date')}}","ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","vn-equals":"$ctrl.lodash.get($ctrl.bonus_project, (config_field.settings.equals.key))","ng-disabled":"!$ctrl.canEditConfigKey(config_field)","ng-required":"$ctrl.lodash.get(config_field, 'settings.is_required', true)"},"fieldHtmlClass": "dateInput","validationMessages": {"required":"Es wird eine Eingabe benötigt","dateMin":"Das Datum muss nach dem {{$ctrl.getDate($ctrl.lodash.get($ctrl, (config_field.settings.date.min.key))) | date}} liegen","dateMax":"Das Datum muss vor dem {{$ctrl.getDate($ctrl.lodash.get($ctrl, (config_field.settings.date.max.key))) | date}} liegen","parse":"Bitte geben Sie das Datum an."}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.base_info"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"$ctrl.bonus_project.config_fields.budget.length &gt; 0\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBausteine aktivieren\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E";
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"bonus-budget-form-row\" ng-repeat=\"config_field in $ctrl.bonus_project.config_fields.budget | filter: { is_visible: true }\" ng-init=\"config_field_index=$index\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "{{config_field_index}}","key": "$ctrl.bonus_project.budget_config[config_field.prop].enabled","data-cy": "vn.cockpit.bonus.createProjectDialog.checkEnableComponent-{{config_field.prop}}","attributes": {"ng-change":"$ctrl.handleComponentEnableChange(config_field.prop)","ng-disabled":"!$ctrl.can_edit"}}
});
pug_html = pug_html + "\u003Cdiv class=\"field_label\"\u003E{{ config_field.label }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"settings\" ng-repeat=\"setting in config_field.settings\"\u003E";
pug_mixins["checkbox"].call({
attributes: {"title": "{{ setting.label }}","key": "$ctrl.lodash.get($ctrl.bonus_project.budget_config, (config_field.prop + setting.parent))[setting.key]","id": "checkbox.{{config_field_index}}-{{$index}}","data-cy": "{{setting.cyData}}","attributes": {"ng-disabled":"!$ctrl.bonus_project.budget_config[config_field.prop].enabled || !$ctrl.can_edit || setting.settings.is_editable === false","ng-model-options":"{ debounce: 1000 }","ng-required":"$ctrl.bonus_project.budget_config[config_field.prop].enabled","ng-change":"$ctrl.settingChanged()"},"groupAttributes": {"ng-if":"setting.type === 'checkbox' && $ctrl.lodash.get(setting, 'settings.is_visible', true)"},"validationMessages": {"required":"Bitte Eingabe prüfen"}}
});
pug_mixins["input"].call({
attributes: {"title": "{{ setting.label }}","key": "$ctrl.lodash.get($ctrl.bonus_project.budget_config, (config_field.prop + setting.parent))[setting.key]","id": "input.{{config_field_index}}-{{$index}}","attributes": {"ng-disabled":"!$ctrl.bonus_project.budget_config[config_field.prop].enabled || !$ctrl.can_edit || setting.settings.is_editable === false","ng-model-options":"{ debounce: 1000 }","vn-currency":"{{ setting.attributes.currency }}","ng-required":"$ctrl.bonus_project.budget_config[config_field.prop].enabled","ng-change":"$ctrl.settingChanged()"},"groupAttributes": {"ng-if":"(setting.type === 'input' || setting.type === undefined ) && $ctrl.lodash.get(setting, 'settings.is_visible', true)"},"data-cy": "{{setting.cyData}}","validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen"}}
});
pug_html = pug_html + "\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"dateInput\" date-refocus=\"true\" ng-if=\"setting.type === 'datetime' &amp;&amp; $ctrl.lodash.get(setting, 'settings.is_visible', true) &amp;&amp; $ctrl.validateConditions(setting.conditions)\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project.budget_config, (config_field.prop + setting.parent))[setting.key]","title": "{{setting.label}}","id": "date.{{config_field_index}}-{{$index}}","validationId": "\"date.\" + config_field_index + \"-\" + $index","data-cy": "{{setting.cyData}}","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-use-utc":"true","ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","ng-disabled":"!$ctrl.bonus_project.budget_config[config_field.prop].enabled || !$ctrl.can_edit || setting.settings.is_editable === false","ng-required":"!(!$ctrl.bonus_project.budget_config[config_field.prop].enabled || !$ctrl.can_edit || setting.settings.is_editable === false)"},"fieldHtmlClass": "dateInput","validationMessages": {"required":"Es wird eine Eingabe benötigt","parse":"Bitte geben Sie das Datum an."}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.lodash.get($ctrl.bonus_project.budget_config, (config_field.prop + setting.parent))[setting.key]","title": "{{setting.label}}","id": "select.{{config_field_index}}{{$index}}","data-cy": "{{setting.cyData}}","validationMessages": {"required":"Es wird eine Eingabe benötigt"},"groupAttributes": {"ng-if":"setting.type === 'select' && $ctrl.lodash.get(setting, 'settings.is_visible', true)"},"attributes": {"ng-options":"option.id as option.display for option in $ctrl.lodash.get($ctrl, (setting.options.parent), $ctrl)[setting.options.key]","ng-disabled":"!$ctrl.can_edit || setting.settings.is_editable === false || !$ctrl.bonus_project.budget_config[config_field.prop].enabled","ng-required":"!(!$ctrl.can_edit || setting.settings.is_editable === false || !$ctrl.bonus_project.budget_config[config_field.prop].enabled)"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.components"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel\" ng-if=\"$ctrl.bonus_project.config_fields.notifications.length &gt; 0\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EBonus Notifications\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\" overlay=\"$ctrl.loading.notifications\"\u003E";
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"bonus-budget-form-row\" ng-repeat=\"notification in $ctrl.bonus_project.config_fields.notifications\" ng-init=\"notification_index=$index\"\u003E\u003Cdiv\u003E{{notification.title}}\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cdiv class=\"quill-editor\"\u003E\u003Cng-quill-editor class=\"quill-content\" id=\"allgemein-content\" name=\"inputWelcomeNotificationContent\" ng-model=\"notification.text\" key=\"$ctrl.lodash.get($ctrl.bonus_project, (notification.parent))[notification.key]\" theme=\"snow\" placeholder=\"Text hier eingeben…\"\u003E\u003C\u002Fng-quill-editor\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\" $ctrl.bonus_project.project_state === $ctrl.BONUS_PROJECT_STATES_BY_NAME['published']['id']\"\u003E\u003Cbutton class=\"button right\" overlay=\"$ctrl.loading.saving\" type=\"button\" ng-click=\"$ctrl.updateBonusProjectNotifications()\" ng-disabled=\"!$ctrl.forms.notifications.$valid\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.notifications"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ccockpit-panel overlay=\"$ctrl.loading.import_file\" ng-if=\"$ctrl.bonuses_for_employees\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003EEmployees\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E";
pug_mixins["dropzone"].call({
attributes: {"ng-if": "$ctrl.can_edit"}
}, '$ctrl.models.import_file', true);
pug_html = pug_html + "\u003Cdiv ng-if=\"!$ctrl.can_edit\"\u003EYou can not change the users on this project\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"employee bonus-budget-form-row\" ng-repeat=\"(employee_id, employee_data) in $ctrl.bonuses_for_employees\"\u003E\u003Cdiv\u003E";
pug_mixins["checkbox"].call({
attributes: {"id": "bonus-give-{{employee_id}}","key": "$ctrl.bonuses_for_employees[employee_id].to_get","data-cy": "vn.cockpit.bonus.createProjectDialog.checkGiveBonus-{{employee_id}}","title": "{{employee_data.id}}  -  {{ employee_data.lastname }}, {{ employee_data.firstname }}","attributes": {"ng-disabled":"!$ctrl.can_edit","ng-change":"$ctrl.handleEmployeeBonusToggle(employee_id)"}}
});
pug_mixins["checkbox"].call({
attributes: {"key": "$ctrl.bonuses_for_employees[employee_id].is_church_tax_enabled","id": "church_tax-{{$index}}","title": "KiST","data-cy": "vn.cockpit.bonus.createProjectDialog.checkChurchTax-{{employee_id}}","attributes": {"ng-disabled":"!$ctrl.bonuses_for_employees[employee_id].to_get || !$ctrl.can_edit","ng-change":"$ctrl.handleEmployeeConfigurationChange(employee_id)"}}
});
pug_mixins["select"].call({
attributes: {"key": "$ctrl.bonuses_for_employees[employee_id].steuer_klasse","title": "Stkl","id": "bonus-stkl-{{$index}}","validationId": "'bonus-stkl-' + $index","data-cy": "vn.cockpit.bonus.createProjectDialog.selectTaxClass-{{employee_id}}","attributes": {"ng-disabled":"!$ctrl.bonuses_for_employees[employee_id].to_get || !$ctrl.can_edit","ng-required":"$ctrl.isEmployeeInformationRequired(employee_id)","ng-change":"$ctrl.handleEmployeeConfigurationChange(employee_id)","ng-options":"stkl.value as stkl.name for stkl in $ctrl.SteuerklassenConstants"},"groupAttributes": {"id":"stklClassForm"},"validationMessages": {"required":"Geben Sie Ihre Steuerklasse an."}}
});
pug_mixins["input"].call({
attributes: {"key": "$ctrl.bonuses_for_employees[employee_id].bonus_amount","id": "bonus-value-{{$index}}","title": "Bonuswert","validationId": "'bonus-value-' + $index","data-cy": "vn.cockpit.bonus.createProjectDialog.inputBonusAmount-{{employee_id}}","attributes": {"ng-disabled":"!$ctrl.bonuses_for_employees[employee_id].to_get || !$ctrl.can_edit","ng-model-options":"{ debounce: 1000 }","vn-currency":"true","ng-required":"$ctrl.isEmployeeInformationRequired(employee_id)","ng-change":"$ctrl.handleEmployeeConfigurationChange(employee_id)","vn-min":"{{ $ctrl.isEmployeeInformationRequired(employee_id) ? 1 : 0 }}"},"validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Geben Sie die Höhe der Einmalzahlung an.","vnMin":"Der minimale Wert beträgt {{ 1 | currency }}"}}
});
pug_html = pug_html + "\u003Csection\u003E\u003Cdiv class=\"bonusCalcData\"\u003E\u003Cdiv class=\"bonusCalcDataCol\"\u003EVerbraucht\u003C\u002Fdiv\u003E\u003Cdiv class=\"bonusCalcDataCol\"\u003ERest\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"sumRow\"\u003E\u003Cdiv class=\"bonusCalcDataCol usedBonus\"\u003E{{ ($ctrl.bonusAmountsByEmployeeIds[employee_id] ? $ctrl.bonusAmountsByEmployeeIds[employee_id].used_bonus : 0) | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"bonusCalcDataCol\" ng-style=\"($ctrl.bonusAmountsByEmployeeIds[employee_id] &amp;&amp; $ctrl.bonusAmountsByEmployeeIds[employee_id].rest_bonus &lt; 0) &amp;&amp; {&quot;color&quot;: &quot;red&quot;}\"\u003E{{ ($ctrl.bonusAmountsByEmployeeIds[employee_id] ? $ctrl.bonusAmountsByEmployeeIds[employee_id].rest_bonus : 0) | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"helpText\" ng-if=\"$ctrl.bonusAmountsByEmployeeIds[employee_id] &amp;&amp; $ctrl.bonusAmountsByEmployeeIds[employee_id].total_bonus_budget  &lt; $ctrl.bonusAmountsByEmployeeIds[employee_id].used_bonus\"\u003EBonus-Budget unterschreitet das aktuell verfügbare Rest-Budget des Mitarbeiters\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "$ctrl.forms.users"}
});
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003C\u002Fcockpit-panel\u003E\u003Ccockpit-panel ng-if=\"$ctrl.bonus_project.project_type\"\u003E\u003Cdiv class=\"cockpit-panel__body\"\u003E\u003Cdiv ng-if=\" $ctrl.bonus_project.project_state === $ctrl.BONUS_PROJECT_STATES_BY_NAME['draft']['id']\"\u003E\u003Cbutton class=\"button left\" type=\"button\" overlay=\"$ctrl.loading.saving\" ng-click=\"$ctrl.save()\" ng-disabled=\"!$ctrl.canSaveProject()\" data-cy=\"vn.cockpit.bonus.createProjectDialog.buttonSaveDraft\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003Cbutton class=\"button right\" type=\"button\" overlay=\"$ctrl.loading.confirm\" ng-click=\"$ctrl.confirm()\" data-cy=\"vn.cockpit.bonus.createProjectDialog.buttonActivateProject\" ng-disabled=\"!$ctrl.canSaveProject()\"\u003EProjekt veröffentlichen1\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\" $ctrl.bonus_project.project_state === $ctrl.BONUS_PROJECT_STATES_BY_NAME['confirmed']['id']\"\u003E\u003Cp class=\"error\" ng-if=\"!$ctrl.validations.can_publish_project.overall\"\u003ECan not publish this project because it collides with '{{ $ctrl.validations.can_publish_project.validations.collision_bonus_project.name }}' bonus project.\u003C\u002Fp\u003E\u003Cbutton class=\"button left\" ng-if=\"$ctrl.bonus_project.project_type !== $ctrl.BONUS_PROJECT_TYPES_BY_NAME['direct_bonus']['id']\" type=\"button\" ng-click=\"$ctrl.revoke()\" data-cy=\"vn.cockpit.bonus.createProjectDialog.buttonDeactivateProject\"\u003EAktivierung zurücknehmen\u003C\u002Fbutton\u003E\u003Cbutton class=\"button right\" type=\"button\" ng-click=\"$ctrl.publish()\" overlay=\"$ctrl.loading.publish\" data-cy=\"vn.cockpit.bonus.createProjectDialog.buttonPublishProject\" ng-disabled=\"!$ctrl.canPublishProject()\"\u003EProjekt veröffentlichen2\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\" $ctrl.bonus_project.project_state === $ctrl.BONUS_PROJECT_STATES_BY_NAME['published']['id']\"\u003E\u003Cbutton class=\"button left\" overlay=\"$ctrl.loading.saving\" ng-if=\"$ctrl.can_edit\" type=\"button\" data-cy=\"vn.cockpit.bonus.createProjectDialog.buttonSaveChanges\" ng-click=\"!$ctrl.canSaveProject() || $ctrl.save()\" ng-disabled=\"!$ctrl.canSaveProject()\"\u003ESpeichern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fcockpit-panel\u003E";
    }.call(this, "containerAttributes" in locals_for_with ?
        locals_for_with.containerAttributes :
        typeof containerAttributes !== 'undefined' ? containerAttributes : undefined, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "fileInputAttributes" in locals_for_with ?
        locals_for_with.fileInputAttributes :
        typeof fileInputAttributes !== 'undefined' ? fileInputAttributes : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;